import { apiRequest } from './client'
import { DemoTenant, DemoTenantDetail, CreateDemoTenantInput, PatchDemoTenantInput } from '../../types/branding'

async function uploadLogoFile(tenantId: string, file: File): Promise<{ url: string }> {
  const formData = new FormData()
  formData.append('file', file)
  return apiRequest<{ url: string }>(`/admin/demo-tenants/${tenantId}/logo`, {
    method: 'POST',
    body: formData,
  })
}

export const demoTenantsApi = {
  uploadLogo: uploadLogoFile,

  async list(): Promise<DemoTenant[]> {
    const data = await apiRequest<{ tenants: DemoTenant[] }>('/admin/demo-tenants')
    return data.tenants ?? []
  },

  async create(data: CreateDemoTenantInput): Promise<DemoTenant> {
    const { logoFile, ...rest } = data
    const response = await apiRequest<{ tenant: DemoTenant }>('/admin/demo-tenants', {
      method: 'POST',
      body: rest,
    })
    const tenant = response.tenant
    if (logoFile) {
      await uploadLogoFile(tenant.id, logoFile)
    }
    return tenant
  },

  async getById(id: string): Promise<DemoTenantDetail> {
    const data = await apiRequest<{ tenant: DemoTenantDetail }>(`/admin/demo-tenants/${id}`)
    return data.tenant
  },

  async update(id: string, body: PatchDemoTenantInput): Promise<DemoTenant> {
    const data = await apiRequest<{ tenant: DemoTenant }>(`/admin/demo-tenants/${id}`, {
      method: 'PATCH',
      body,
    })
    return data.tenant
  },

  async extend(id: string, days: number): Promise<void> {
    await apiRequest(`/admin/demo-tenants/${id}/extend`, {
      method: 'POST',
      body: { days },
    })
  },

  async regenerateCredentials(id: string): Promise<{ oneTimeCredentials: { email: string; password: string }[] }> {
    return apiRequest(`/admin/demo-tenants/${id}/regenerate-credentials`, { method: 'POST' })
  },

  async reset(id: string): Promise<void> {
    await apiRequest(`/admin/demo-tenants/${id}/reset`, { method: 'POST' })
  },

  async remove(id: string): Promise<void> {
    await apiRequest(`/admin/demo-tenants/${id}`, { method: 'DELETE' })
  },
}
